import React, { useEffect, useState, useRef } from 'react';
import L from 'leaflet';
import { useMap } from 'react-leaflet/hooks';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectRandom,
  selectNext,
  selectPrevious,
  selectQueried,
} from './MyMap.js';
import {
  connectWallet,
  connectCoinbase,
  connectWalletConnect,
} from './redux/blockchain/blockchainActions';
import { fetchData } from './redux/data/dataActions';
import contract from './redux/config/config.json';
import configuration from '../data/config.json';
import polygonJson from '../data/geo_json_string.json';
import ownership_full from '../data/availability_list.json';
import OpenseaIcon from '../images/opensea.png';
import DetectDevice from './DeviceDetector.js';
import '../styles/sidebar.css';
import { IoIosArrowBack, IoIosArrowForward, IoIosClose } from 'react-icons/io';
import { IoCopyOutline, IoOpenOutline } from 'react-icons/io5';
import { TiArrowShuffle } from 'react-icons/ti';
import { RiArrowGoBackFill } from 'react-icons/ri';
import { NumericFormat } from 'react-number-format';
import { setSelectedSubregionNull } from './MyMap.js';
import { isMobile, isMobileSafari, isTablet } from 'react-device-detect';
import { CgSoftwareDownload } from 'react-icons/cg';

import { getPrompts } from './Popout.js';

import { Alchemy, Network } from 'alchemy-sdk';
import Web3 from 'web3';

import { StandardMerkleTree } from '@openzeppelin/merkle-tree';
import merkle_tree from '../data/tree.json';
import TokenProgress from './TokenProgress.js';

const contractABI = require('./contract-abi.json');
const tokenContractABI = require('./token-abi.json');

//const contractAddress = String(contract.CONTRACT_ADDRESS);
const { createAlchemyWeb3 } = require('@alch/alchemy-web3');

var alch_network;
var alch_key;
var alchemyKey;
var contractAddress;
var opensea_key;
var tpx_address; 

if (contract.NETWORK.ID == 1) {
  // Initialization
  alch_key = contract.ALCH_KEY;
  alch_network = Network.ETH_MAINNET;
  alchemyKey = contract.ALCH_KEY_LINK;
  contractAddress = String(contract.CONTRACT_ADDRESS);
  opensea_key = contract.OPENSEA_KEY;
  tpx_address = String(contract.TPX_ADDRESS);
}
if (contract.NETWORK.ID == 5) {
  // Initialization
  alch_key = contract.ALCH_KEY_TEST;
  alch_network = "eth-sepolia"; //Network.ETH_SEPOLIA;
  alchemyKey = contract.ALCH_KEY_TEST_LINK;
  contractAddress = String(contract.CONTRACT_ADDRESS_GOERLI);
  opensea_key = contract.OPENSEA_KEY;
  tpx_address = String(contract.TPX_ADDRESS_GOERLI);
}
const alc_config = {
  apiKey: alch_key,
  network: alch_network,
};
const alchemy = new Alchemy(alc_config);
const alch_web3 = createAlchemyWeb3(alchemyKey);

var copyTimer = null;

function getNum(numString) {
  let num = numString.split('-')[1];
  return num;
}

function getPrice(numString) {
  return parseInt(numString, 10) * 0.00000025;
}

// NOTE : GETTING DIMENSIONS INCORRECt
function getWidth(numString) {
  return Math.sqrt(parseInt(numString, 10));
}

export var subregionModeOn = false;
export var defaultSidebarHeight = 0;
var isMobileFullView = false;


async function getExchangeRate() {
  let USDTOETH;
  const res = await fetch('https://api.coinbase.com/v2/exchange-rates');
  USDTOETH = await res.json();
  USDTOETH = USDTOETH.data.rates.ETH;
  return 1 / USDTOETH;
}

var full_view = 0;

var video_path = '';
var poster_path = '';

function Sidebar({
  sidebarTitle,
  masterTile,
  setPopout,
  setSidebar,
  gridOverlay,
  sidebarState,
  setMasterTile,
  setSidebarTitle,
  currentPrompt,
  setCurrentPrompt,
  subregionMode,
  setSubregionMode,
  setMintMessage,
  setRevertMessage,
  singleRegion,
  isPaused,
  frameNum,
  setShowBanner,
  mintingPaused,
  mintingCountdown,
  affiliate,
  tilePreview,
  setTilePreview,
  mintingOverride,
  redactNFTs,
  physicalClaimed,
  setphysicalClaimed,
  renderNumber,
  ownership,
  setOwnership,
}) {
  const map = useMap();
  const sidebarRef = useRef(null);
  const currentTile = masterTile.masterTile;
  //init State vars
  const [ETHTOUSD, setExchange] = useState('');
  const [currentTileOwner, setCurrentTileOwner] = useState('');
  const [currentMintPrice, setCurrentMintPrice] = useState(
    Number(currentTile.tokenId) * 250000000000
  );
  const [currentETHPrice, setCurrentETHPrice] = useState(
    (Number(currentTile.tokenId) * 250000000000) / 1000000000000000000
  );
  const [calcPrice, setCalcPrice] = useState(getPrice(currentTile.tokenId));
  const [tileLink, setTileLink] = useState('');
  const [isDiscount, setIsDiscount] = useState(false);
  const [listedPrice, setListedPrice] = useState(null);
  const [TPXclaimed, setTPXclaimed] = useState(false);

  const selectRandomClone = ({
    map,
    gridOverlay,
    sidebarState,
    setMasterTile,
    setSidebarTitle,
    shouldZoom,
    setCurrentPrompt,
    isMobileFullView,
  }) =>
    selectRandom({
      map,
      gridOverlay,
      sidebarState,
      setMasterTile,
      setSidebarTitle,
      shouldZoom,
      setCurrentPrompt,
      isMobileFullView,
    });
  const selectNextClone = ({
    map,
    gridOverlay,
    sidebarState,
    setMasterTile,
    setSidebarTitle,
    shouldZoom,
    currentTile,
    setCurrentPrompt,
  }) =>
    selectNext({
      map,
      gridOverlay,
      sidebarState,
      setMasterTile,
      setSidebarTitle,
      shouldZoom,
      currentTile,
      setCurrentPrompt,
      isMobileFullView,
    });
  const selectPreviousClone = ({
    map,
    gridOverlay,
    sidebarState,
    setMasterTile,
    setSidebarTitle,
    shouldZoom,
    currentTile,
    setCurrentPrompt,
    isMobileFullView,
  }) =>
    selectPrevious({
      map,
      gridOverlay,
      sidebarState,
      setMasterTile,
      setSidebarTitle,
      shouldZoom,
      currentTile,
      setCurrentPrompt,
      isMobileFullView,
    });
  const selectQueriedClone = ({
    map,
    gridOverlay,
    sidebarState,
    setMasterTile,
    setSidebarTitle,
    shouldZoom,
    queryNumObject,
    setCurrentPrompt,
    setTilePreview,
  }) =>
    selectQueried({
      map,
      gridOverlay,
      sidebarState,
      setMasterTile,
      setSidebarTitle,
      shouldZoom,
      queryNumObject,
      setCurrentPrompt,
      setTilePreview,
    });
  const [promptData, setPrompt] = useState({
    type: 'FeatureCollection',
    features: [{ type: 'FeatureCollection', features: [] }],
  });
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const [trackVideoRect, setTrackVideoRect] = useState(null);

  // document.addEventListener("keydown", prevnext);
  function prevnext(event) {
    if (event.code === 'ArrowLeft') {
      // Left arrow key pressed
      // Navigate to the previous page

      let shouldZoom = 1;
      selectPrevious({
        map,
        gridOverlay,
        sidebarState,
        setMasterTile,
        setSidebarTitle,
        shouldZoom,
        currentTile,
        setCurrentPrompt,
      });
      setSubregionMode(-1);
      setCurrentPrompt(null);
      console.log('prev');
      return;
    } else if (event.code === 'ArrowRight') {
      // Right arrow key pressed
      // Navigate to the next page

      console.log('next');
      let shouldZoom = 1;
      selectNext({
        map,
        gridOverlay,
        sidebarState,
        setMasterTile,
        setSidebarTitle,
        shouldZoom,
        currentTile,
        setCurrentPrompt,
      });
      setSubregionMode(-1);
      setCurrentPrompt(null);
      return;
    }
  }

  if (document.getElementsByClassName('subregion-helper')[0]) {
    let rect = document
      .getElementsByClassName('subregion-helper')[0]
      .getBoundingClientRect();
    if (trackVideoRect !== null) {
      if (
        trackVideoRect.width !== rect.width &&
        trackVideoRect.height !== rect.height
      ) {
        /*
        bottom:267.828125
        height:116.671875
        left: 788.828125
        right: 1018.171875
        top: 151.15625
        width: 229.34375
        x: 788.828125
        y: 151.15625
        */
        if (
          rect.bottom === 267.828125 &&
          rect.height === 116.671875 &&
          rect.top === 151.15625 &&
          rect.width === 229.34375
        ) {
          setTrackVideoRect(null);
        } else {
          setTrackVideoRect(rect);
        }
      }
    } else {
      if (
        rect.bottom === 267.828125 &&
        rect.height === 116.671875 &&
        rect.top === 151.15625 &&
        rect.width === 229.34375
      ) {
      } else {
        setTrackVideoRect(rect);
      }
    }
  }

  var currentTileSold;
  var tileOwner = '';

  function setLink(curTile) {
    var link_base = '';
    if (contract.NETWORK.ID == 1) {
      link_base = 'https://opensea.io/assets/ethereum/';
    }
    if (contract.NETWORK.ID == 5) {
      link_base = 'https://testnets.opensea.io/assets/goerli/';
    }
    let link_with_contract = link_base.concat(String(contractAddress));
    let link2 = link_with_contract.concat('/');
    let full_link = link2.concat(curTile);
    return full_link;
  }
  function setWalletLink(curTile) {
    var link_base = '';
    if (contract.NETWORK.ID == 1) {
      link_base = 'https://etherscan.io/address/';
    }
    if (contract.NETWORK.ID == 5) {
      link_base = 'https://goerli.etherscan.io/address/';
    }
    let full_link = link_base.concat(curTile);
    return full_link;
  }
  function getPackage(currentTile) {
    let package1 =
      polygonJson.features[0].features[parseInt(getNum(currentTile.name))]
        .features[0].properties.collector_package;
    return package1;
  }
  function constructIPFSLink(currentTile) {
    const baseUrl = 'https://ipfs.io/ipfs/';
    let ipfshash;

    // Split the name to get the first word
    const firstWord = currentTile.name.split('-')[0];

    // Determine the token based on the first word
    switch (firstWord) {
      case 'classA':
        ipfshash = 'QmRtraEinRfHWNqm8pbqZ9UK2WAxxbLqjgxqrGyzCDsNHK';
        break;
      case 'classB':
        ipfshash = 'QmYN5143vWmcSsBSTg9MREpsLCmHDBooAt7GXSKfmioAgR';
        break;
      case 'classC':
        ipfshash = 'QmYEK67k2tb95qb8J5p6dVJ4Tposq4LMvpik7j6ax5wzYK';
        break;
      case 'classD':
        ipfshash = 'QmWNT226FFtBkyi4RroH9rs1roBfLFACPri6kbpFi6aqaN';
        break;
      default:
        ipfshash = ''; // Default case if no class matches
    }

    const secondWord = currentTile.name.split('-')[1] || '';
    const finalUrl =
      baseUrl + ipfshash + '/TODEM.' + secondWord + '.collector_package.zip';
    return finalUrl;
  }

  //Blockchain call to TPX contract to see if claimed
  async function hasBeenClaimed(tokenId) {
      window.contract = await new alch_web3.eth.Contract(
        tokenContractABI,
        tpx_address
      ); 
      let claimed = await window.contract.methods
        .tokenClaimed(tokenId)
        .call();
      setTPXclaimed(claimed);
      return claimed
  }

  //Send call to blockchain to determine if user has a discount or not
  async function getMintPrice(tokenId) {
    if (blockchain.account !== '' && blockchain.account !== null) {
      window.contract = await new alch_web3.eth.Contract(
        contractABI,
        contractAddress
      );
      const price = await window.contract.methods
        .getMintPrice(tokenId, blockchain.account)
        .call();
      //console.log(price)
      setCurrentMintPrice(price);
      setCurrentETHPrice(price / 1000000000000000000);
    } else {
      setCurrentMintPrice(Number(tokenId) * 250000000000);
      setCurrentETHPrice(
        (Number(tokenId) * 250000000000) / 1000000000000000000
      );
    }
  }

  /*
  * Update prices on wallet change
  */
  useEffect(() => {
    setCurrentETHPrice(
      (Number(currentTile.tokenId) * 250000000000) / 1000000000000000000
    );
    getMintPrice(currentTile.tokenId);
    setCalcPrice(getPrice(currentTile.tokenId));
  }, [masterTile]);

  useEffect(() => {
    setCurrentETHPrice(
      (Number(currentTile.tokenId) * 250000000000) / 1000000000000000000
    );
    getMintPrice(currentTile.tokenId);
    setCalcPrice(getPrice(currentTile.tokenId));
  }, [blockchain.account]);

  //Using opensea api so fetch listing prices
  async function fetchPixelPrice() {
    const url = 'https://api.opensea.io/v2/listings/collection/todem/all';
    const options = {
      method: 'GET',
      headers: {
        accept: 'application/json',
        'X-API-KEY': opensea_key,
      },
    };
    let listings;

    await fetch(url, options)
      .then((res) => res.json())
      .then((json) => (listings = json.listings));
    const PixelPrices = [];
    const ListedTokens = [];
    for (let listing of listings) {
      let listedPrice0 =
        listing.price.current.value / 10 ** listing.price.current.decimals;
      let listedTokenArea =
        listing.protocol_data.parameters.offer[0].identifierOrCriteria;
      ListedTokens.push(listedTokenArea);
      if (listedTokenArea == currentTile.tokenId) {
        setListedPrice(listedPrice0);
      }
    }
    if (ownership[currentTile.tokenId] == 0) {
      //setListedPrice((currentTile.tokenId*0.00000025).toFixed(5));
      setListedPrice(null);
    } else if (
      !ListedTokens.includes(currentTile.tokenId.toString()) &&
      ownership[currentTile.tokenId] !== 0
    ) {
      setListedPrice(null);
    }
  }

  useEffect(() => {
    //setListedPrice(null);
    fetchPixelPrice();
  }, [masterTile]);

  //Ownership should be automatically updated and synced across components when wallet is connected in top bar but this is a second check
  // If someone mints a tile while another user is surifng the site they won't see that that tile was bought unless we have this second check when a tile is selected
  // This check gets owner of current tile and only updates ownership dict if it does not match
  const checkOwner = async (tokenId) => {
    const address = String(contractAddress);
    try {
      const owner = await alchemy.nft.getOwnersForNft(address, tokenId);
      if (owner !== undefined) {
        if (owner.owners.length !== 0) {
          ownerSuccessHandler(owner);
        }
      } else {
        ownerErrorHandler(owner);
      }
    } catch (e) {
      if(ownership[sidebarTitle] !== 0){
        const updatedOwnership = {...ownership};
        updatedOwnership[sidebarTitle] = 0;
        setOwnership(updatedOwnership);
      }
    }
  };

  function ownerErrorHandler(e) {
    tileOwner = 'wait';
    if(ownership[sidebarTitle] !== 0){
      const updatedOwnership = {...ownership};
      updatedOwnership[sidebarTitle] = 0;
      setOwnership(updatedOwnership);
    }
    return tileOwner;
  }
  function ownerSuccessHandler(owners) {
    setCurrentTileOwner(owners['owners'][0]);
    tileOwner = owners['owners'][0];
    if (tileOwner === blockchain.account) {
      if(ownership[sidebarTitle] !== 2){
        const updatedOwnership = {...ownership};
        updatedOwnership[sidebarTitle] = 2;
        setOwnership(updatedOwnership);
      }
    } else {
      if(ownership[sidebarTitle] !== 1){
        const updatedOwnership = {...ownership};
        updatedOwnership[sidebarTitle] = 1;
        setOwnership(updatedOwnership);
      }
    }
    return tileOwner;
  }

  //Setting discount var for interface
  useEffect(() => {
    if (currentETHPrice.toFixed(2) !== calcPrice.toFixed(2)) {
      setIsDiscount(true);
    } else {
      setIsDiscount(false);
    }
  }, [masterTile, blockchain.account]);

  useEffect(() => {
    checkOwner(sidebarTitle);
  }, [masterTile]);

  useEffect(() => {
    hasBeenClaimed(currentTile.tokenId);
  }, [masterTile, currentTile]);

  useEffect(() => {
    const getExchangeRate = async () => {
      let USDTOETH;
      const res = await fetch('https://api.coinbase.com/v2/exchange-rates');

      USDTOETH = await res.json();
      USDTOETH = USDTOETH.data.rates.ETH;
      setExchange(1 / USDTOETH);
    };
    getExchangeRate();
  }, []);

  const [pathToVideos] = useState();
  const [overlayOn, setState] = useState(configuration.opacity_on);
  let minters = [];
  let pageKey;
  const data = useSelector((state) => state.data);
  const [claimingNft, setClaimingNft] = useState(false);
  const [feedback, setFeedback] = useState(`Click buy to mint your NFT.`);
  const [mintAmount, setMintAmount] = useState(1);
  const [CONFIG, SET_CONFIG] = useState({
    CONTRACT_ADDRESS: '',
    SCAN_LINK: '',
    NETWORK: {
      NAME: '',
      SYMBOL: '',
      ID: 0,
    },
    NFT_NAME: '',
    SYMBOL: '',
    MAX_SUPPLY: 1,
    WEI_COST: 0,
    DISPLAY_COST: 0,
    GAS_LIMIT: 0,
    MARKETPLACE: '',
    MARKETPLACE_LINK: '',
    SHOW_BACKGROUND: false,
  });

  async function getRevertReason(txHash) {
    let web3;
    web3 = new Web3(window.ethereum);

    const tx = await web3.eth.getTransaction(txHash);
    try {
      const transaction = await web3.eth.call(tx, tx.blockNumber);
      const receipt = await transaction;
    } catch (e) {
      const err = e.message.toString().split('{')[0];
      setRevertMessage(err);
    }
  }

  // function to get all the minters of the NFT Collection
  // Used to set a mint limit
  async function getMinters() {
    let firstCall = true;
    while (firstCall || pageKey) {
      let res;
      if (pageKey) {
        res = await alchemy.core.getAssetTransfers({
          fromAddress: '0x0000000000000000000000000000000000000000',
          category: ['erc721'],
          contractAddresses: [contractAddress],
          pageKey: pageKey,
        });
      } else {
        res = await alchemy.core.getAssetTransfers({
          fromAddress: '0x0000000000000000000000000000000000000000',
          category: ['erc721'],
          contractAddresses: [contractAddress],
        });
      }
      firstCall = false;
      for (let i = 0; i < res.transfers.length; i++) {
        const transfer = res.transfers[i];
        minters.push(transfer.to);
      }
      pageKey = res.pageKey;
    }

    var count_num_mints = 0;
    for (const minter of minters) {
      if (minter === blockchain.account) {
        count_num_mints = count_num_mints + 1;
      }
    }
    return count_num_mints;
  }

  function mintNFT(tile_to_mint) {
    /*setCurrentETHPrice(
      (Number(tile_to_mint) * 250000000000) / 1000000000000000000
    );*/
    getMintPrice(tile_to_mint);
    setCalcPrice(getPrice(tile_to_mint));

    getMinters().then((result) => mintHandler(result, tile_to_mint));
  }

  // async function mintNFT(tile_to_mint) {
  //   window.contract = await new alch_web3.eth.Contract(contractABI, contractAddress);
  //   await window.contract.methods.mint(Number(tile_to_mint)).call();
  // }

  //THis is a triple check. When someone clicks mint we need to make sure no one minted the tile just before them 
  // so they don't end up wasting gas.
  async function checkOwnedSafety(tokenId) {
    if (blockchain.account !== '' && blockchain.account !== null) {
      window.contract = await new alch_web3.eth.Contract(
        contractABI,
        contractAddress
      );
      const isAvail = await window.contract.methods
        .ownerOf(tokenId)
        .call()
        .catch((e) => console.log(e));
      if (isAvail === null || isAvail === undefined || isAvail === '') {
        return true;
      } else {
        return false;
      }
    }
  }
  //Part of the mint safety sequence
  function mintHandler(num_minted, tile_to_mint) {
    if (num_minted < 100) {
      checkOwnedSafety(tile_to_mint).then((result) =>
        mintGo(result, tile_to_mint)
      );
    } else {
      setMintMessage('over_limit');
      setRevertMessage('Wallet has already minted 100');
    }
  }
  //Part of the mint safety sequence
  function mintGo(ownerCheck, tile_to_mint) {
    if (ownerCheck) {
      claimNFTs(tile_to_mint);
    } else {
      setMintMessage('err');
      setRevertMessage('Tile already minted');
    }
  }

  const claimNFTs = (tile_to_mint) => {
    let cost = Number(tile_to_mint) * 250000000000; //CONFIG.WEI_COST;
    let gasLimit = CONFIG.GAS_LIMIT;
    let totalCostWei = String(currentMintPrice); //String(cost * mintAmount);
    let totalGasLimit = String(gasLimit * mintAmount);
    var proof = null;

    const tree = StandardMerkleTree.load(merkle_tree);
    for (const [i, v] of tree.entries()) {
      if (v[0] === Number(tile_to_mint).toString()) {
        proof = tree.getProof(i);
        console.log('Value:', v);
        console.log('Proof:', proof);
      }
    }

    console.log('Cost: ', totalCostWei);
    console.log('Gas limit: ', totalGasLimit);
    setFeedback(`Minting your ${CONFIG.NFT_NAME}...`);
    setClaimingNft(true);
    setMintMessage('minting');
    blockchain.smartContract.methods
      .mint(Number(tile_to_mint), proof)
      .send({
        gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
        value: totalCostWei,
      })
      .once('error', (err, receipt) => {
        try {
          setClaimingNft(false);
          setFeedback('Sorry, something went wrong please try again later.');
          getRevertReason(receipt.transactionHash);
          setMintMessage(receipt.transactionHash);
        } catch (e) {
          setMintMessage(null);
        }
      })
      .then((receipt) => {
        console.log(receipt);
        setFeedback(
          `The ${CONFIG.NFT_NAME}s are yours, head to the studio to use them.`
        );
        const updatedOwnership = {...ownership};
        updatedOwnership[tile_to_mint] = 2;
        setOwnership(updatedOwnership);
        setCurrentTileOwner(blockchain.account);
        setClaimingNft(false);
        setMintMessage('claimed');
        document.getElementsByClassName('sidebar')[0].style =
          'background-color: #FEBE32e6;';
        dispatch(fetchData(blockchain.account));
      });
  };

  const getData = () => {
    if (blockchain.account !== '' && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
    }
  };

  const getConfig = async () => {
    SET_CONFIG(contract);
  };

  useEffect(() => {
    getConfig();
  }, []);

  useEffect(() => {
    getData();
  }, [blockchain.account]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await fetch(
        'https://www.latentculture.com/tohm/galactic-react/src/data/small_geojsons/' +
          masterTile.masterTile.name +
          '.json'
      );
      var prompt_data = await res.json();
      setPrompt(prompt_data);
    };
    const fetchClaimedPhysicals = async () => {
      const res = await fetch(
        'https://www.latentculture.com/logging/galactic-logger/physical_content/' +
          getNum(currentTile.name) +
          '.json'
      ).catch((e) => console.log(e));
      if (res) {
        setphysicalClaimed(true);
      } else {
        setphysicalClaimed(false);
      }
    };
    if (masterTile.masterTile.name !== 'Click on a tile!') {
      fetchData();
      //fetchClaimedPhysicals();
    }
  }, [currentTile]);

  useEffect(() => {
    if (currentTile.tokenId !== 'NaN') {
      if (typeof video_path !== undefined) {
        let temp = video_path;

        if (renderNumber == 42) {
          video_path = configuration.path_to_videos.concat(
            currentTile.name,
            '.mp4'
          );
          poster_path = `https://www.latentculture.com/tohm/render_${renderNumber}/data/poster/${currentTile.name}.jpg`;
          // `https://www.latentculture.com/tohm/frame.01-512/${currentTile.name}.jpg`;
        }
        if (renderNumber == 14) {
          video_path = configuration.path_to_videos_14.concat(
            currentTile.name,
            '.mp4'
          );
          poster_path = `https://www.latentculture.com/tohm/render_${renderNumber}/data/poster/${currentTile.name}.jpg`;
          //`https://www.latentculture.com/tohm/frame.01-512/${currentTile.name}.jpg`;
        }
        if (renderNumber == 56) {
          video_path = configuration.path_to_videos_56.concat(
            currentTile.name,
            '.mp4'
          );
          poster_path = `https://www.latentculture.com/tohm/render_${renderNumber}/data/poster/${currentTile.name}.jpg`;
          //  `https://www.latentculture.com/tohm/frame.01-512/${currentTile.name}.jpg`;
        }

        if (temp !== video_path) {
          const videoElement = document.getElementsByClassName('video1')[0];
          if (videoElement !== undefined) {
            videoElement.style.color = 'transparent';
          }
        }
      } else {
        video_path = '';
        poster_path = '';
        const videoElement = document.getElementById('video1');
        if (videoElement !== undefined) {
          videoElement.style.color = 'transparent';
        }
      }
    }
  }, [currentTile, renderNumber]);

  // ---- FOR MOBILE SWIPING ----- //
  // adaptation of https://stackoverflow.com/questions/2264072/detect-a-finger-swipe-through-javascript-on-the-iphone-and-android //

  const [scrollEnabled, setScrollEnabled] = useState(false);
  const [allowDragging, setAllowDragging] = useState(true);

  var xDown = null;
  var yDown = null;

  var top = 94;
  var middle = 33;
  var bottom = 16;
  var currentHeight;
  var lastY;

  var currentState = 'middle';

  var sidebar = document.getElementsByClassName('sidebar')[0];

  if (full_view) {
    let loading = document.getElementsByClassName('loading')[0];
    loading.style.display = 'none';
    loading.style.visibility = 'hidden';
  }

  function mobileDefaultView() {
    full_view = 0;
    var video = document.getElementsByClassName('grid-item-2')[0];
    var container = document.getElementById('grid-container-container');

    container.style.overflow = 'hidden';
    container.style.scrollSnapAlign = 'start';

    var infoBox = document.getElementsByClassName('grid-item-3')[0];
    infoBox.style.visibility = 'visible';
    infoBox.style.display = 'block';

    var video = document.getElementsByClassName('grid-item-2')[0];
    video.style.visibility = 'hidden';
    video.style.display = 'none';

    var topnum = document.getElementsByClassName('grid-item-1')[0];
    topnum.style.borderBottomLeftRadius = 0;
    topnum.style.borderBottomRightRadius = 0;
    topnum.style.borderBottomWidth = '0.8px';

    var dim = document.getElementsByClassName('grid-item-3')[0];
    dim.style.borderTopLeftRadius = 0;
    dim.style.borderTopRightRadius = 0;

    var price = document.getElementsByClassName('text-item')[0];
    price.style.visibility = 'hidden';
    price.style.display = 'none';

    var long = document.getElementsByClassName('text-item')[1];
    long.style.visibility = 'hidden';
    long.style.display = 'none';

    // var short = document.getElementById('dimensions');
    // short.style.visibility = 'visible';
    // short.style.display = 'block';

    var classL = document.getElementsByClassName('text-item')[2];
    classL.style.visibility = 'hidden';
    classL.style.display = 'none';

    var filler = document.getElementsByClassName('text-item')[4];
    filler.style.visibility = 'hidden';
    filler.style.display = 'none';

    // var dimensions = document.getElementById('shortLabel');
    // dimensions.style.visibility = 'visible';
    // dimensions.style.display = 'block';

    // var subtile = document.getElementsByClassName('text-item')[5];
    // subtile.style.visibility = 'hidden';
    // subtile.style.display = 'none';

    var playbox = document.getElementsByClassName('bttn frame-controller')[0];
    playbox.style.visibility = 'visible';

    var toggleRenderButton =
      document.getElementsByClassName('toggleRenderButton')[0];
    toggleRenderButton.style.visibility = 'visible';

    map.dragging.enable();

    let heightSB = document.getElementsByClassName('sidebar')[0];

    if (heightSB) {
      defaultSidebarHeight = heightSB.offsetHeight;
    }
    isMobileFullView = false;
  }

  function mobileFullView() {
    full_view = 1;

    var video = document.getElementsByClassName('grid-item-2')[0];
    var container = document.getElementById('grid-container-container');
    video.style.visibility = 'visible';
    video.style.display = 'block';

    container.style.overflow = 'hidden';

    var infoBox = document.getElementsByClassName('grid-item-3')[0];
    infoBox.style.visibility = 'visible';
    infoBox.style.display = 'block';

    var topnum = document.getElementsByClassName('grid-item-1')[0];
    topnum.style.borderBottomLeftRadius = '7px';
    topnum.style.borderBottomRightRadius = '7px';

    var dim = document.getElementsByClassName('grid-item-3')[0];
    dim.style.borderTopLeftRadius = '7px';
    dim.style.borderTopRightRadius = '7px';

    var long = document.getElementsByClassName('text-item')[1];
    long.style.visibility = 'visible';
    long.style.display = 'block';

    var short = document.getElementById('dimensions');
    short.style.visibility = 'visible';
    short.style.display = 'block';

    var classL = document.getElementsByClassName('text-item')[2];
    classL.style.visibility = 'visible';
    classL.style.display = 'block';

    // var filler = document.getElementsByClassName('text-item')[3];
    // filler.style.visibility = 'visible';
    // filler.style.display = 'block';

    var filler = document.getElementsByClassName('text-item')[4];
    filler.style.visibility = 'visible';
    filler.style.display = 'block';

    var dimensions = document.getElementById('shortLabel');
    dimensions.style.visibility = 'visible';
    dimensions.style.display = 'block';

    // var subtile = document.getElementsByClassName('text-item')[5];
    // subtile.style.visibility = 'visible';
    // subtile.style.display = 'block';

    var toggleRenderButton =
      document.getElementsByClassName('toggleRenderButton')[0];
    toggleRenderButton.style.visibility = 'hidden';

    var playbox = document.getElementsByClassName('bttn frame-controller')[0];
    playbox.style.visibility = 'hidden';

    let loading = document.getElementsByClassName('loading')[0];
    loading.style.display = 'none';
    loading.style.visibility = 'hidden';

    // let loading = document.getElementsByClassName("loading")[0]
    // if (loading) {
    //   loading.style.display = "none";
    //   loading.style.visibility = "hidden"

    var background = document.getElementsByClassName('hamburger-background')[0];
    if (
      background.style.visibility === 'hidden' ||
      background.style.visibility === ''
    ) {
      // video.style.height = "calc(100dvh - 317.5px)";
      video.style.height = 'calc(100dvh - 305.5px)';
    } else {
      // video.style.height = "calc(100dvh - 360.5px)";
      video.style.height = 'calc(100dvh - 356.5px)';
    }
    map.dragging.disable();

    isMobileFullView = true;
  }

  function mobileLowestView() {
    full_view = 0;
    var container = document.getElementById('grid-container-container');
    if (container) {
      container.style.scrollSnapAlign = 'start';
    }

    var sidebar = document.getElementsByClassName('sidebar')[0];
    if (sidebar) {
      sidebar.style.animation = 'fadeSidebarOut 0.6s';
    }
    setTimeout(() => {
      setSidebar(0);
    }, 340);
    var darken = document.getElementById('mobile-darken');
    darken.style.animation = 'fadeDarkOut 0.4s';
    darken.style.visibility = 'hidden';
    setSidebar(0);
    var urlId = '/todem/';
    window.history.pushState('', '', urlId);
    var newMasterTile = {
      masterTile: {
        name: 'Click on a tile!',
        tokenId: 'NaN',
        sentimentX_token: '',
        sentimentY_token: '',
        img_prompt: '',
        wiki_token: '',
        rgb: '',
        dimensions: ['', ''],
      },
    };
    setMasterTile(newMasterTile);
    setSelectedSubregionNull();
    setSubregionMode(-1);
    setCurrentPrompt(null);

    map.dragging.enable();

    var toggleRenderButton =
      document.getElementsByClassName('toggleRenderButton')[0];

    toggleRenderButton.style.visibility = 'visible';

    var playbox = document.getElementsByClassName('bttn frame-controller')[0];
    playbox.style.visibility = 'visible';
    playbox.style.transform =
      'translate(calc(50vw - 50px), calc(100dvh - 45px))';

    isMobileFullView = false;
  }

  function mobileClearVideo() {
    var video = document.getElementsByClassName('grid-item-2')[0];
    //var tileInfo = document.getElementsByClassName("grid-item-4")[0];
    video.style.visibility = 'hidden';
    video.style.display = 'none';
    //tileInfo.style.visibility = "hidden";
  }

  var clicked = false;

  function getTouches(evt) {
    return (
      evt.touches || // browser API
      evt.originalEvent.touches
    ); // jQuery
  }

  function handleTouchStart(evt) {
    if (document.getElementsByClassName('prompt-container-mobile')[0]) {
      subregionModeOn = true;
    } else {
      subregionModeOn = false;
    }

    //console.log(subregionModeOn)
    sidebar.style.transition = 'none';
    lastY = evt.touches[0].clientY;
    if ('ontouchstart' in document.documentElement === true) {
      const firstTouch = getTouches(evt)[0];
      xDown = firstTouch.clientX;
      yDown = firstTouch.clientY;
      map.dragging.disable();
      clicked = false;
      // console.log("clicked false");
    } else {
      clicked = true;
    }
  }

  function handleTouchMove(evt) {
    if (subregionModeOn) {
      return;
    }
    var dvh = window.innerHeight;
    currentHeight = 100 - Math.ceil((evt.touches[0].clientY / dvh) * 100);
    lastY = evt.touches[0].clientY;
    sidebar.style.height = currentHeight + 'dvh';
  }

  function handleTouchEnd(evt) {
    //console.log(subregionModeOn)
    if (subregionModeOn) {
      return;
    }
    // console.log("here in end")

    // sidebar.style.transition = "all 2s";
    // var hamburger = document.getElementsByClassName('hamburger-background')[0];
    // var offset = 0;
    // if (hamburger.style.visibility === "visible") {
    //   offset = 6;
    // }

    var container = document.getElementById('grid-container-container');

    var yDiff = yDown - lastY;
    // console.log("in here  yDiff  = " + yDiff);

    var darken = document.getElementById('mobile-darken');

    if (yDiff < -50 && clicked === false) {
      /* down swipe  */
      if (currentHeight <= top && currentHeight >= middle) {
        // from top to middle
        mobileDefaultView();
        currentState = 'middle';
        darken.style.animation = 'fadeDarkOut 0.5s';
        darken.style.visibility = 'hidden';
      } else if (currentHeight < middle) {
        // from middle to bottom
        mobileLowestView();
        // mobileDefaultView();
        currentState = 'bottom';
      }
    } else if (yDiff > 10 && clicked === false) {
      /* up swipe */
      if (!subregionModeOn && currentHeight > middle && currentHeight < top) {
        // from middle to top
        darken.style.display = 'block';
        darken.style.animation = 'fadeDarkIn 0.5s';
        darken.style.visibility = 'visible';
        currentState = 'top';

        darken.onclick = function () {
          var darken = document.getElementById('mobile-darken');
          darken.style.animation = 'fadeDarkOut 0.5s';
          darken.style.visibility = 'hidden';
          mobileDefaultView();
        };

        mobileFullView();
      } else if (currentHeight > bottom) {
        // from bottom to middle
        currentState = 'middle';
        darken.style.animation = 'fadeDarkOut 0.5s';
        darken.style.visibility = 'hidden';
        mobileDefaultView();
      }
    } else if (yDiff === 0) {
      // console.log("y is zero");
    }
    sidebar.style.height = 'fit-content';
  }

  if (sidebar !== undefined && DetectDevice) {
    sidebar.addEventListener('touchstart', handleTouchStart, { passive: true });
    sidebar.addEventListener('touchmove', handleTouchMove, { passive: true });
    sidebar.addEventListener('touchend', handleTouchEnd, { passive: true });
  }

  function getLabel() {
    let label =
      polygonJson.features[0].features[parseInt(getNum(currentTile.name))]
        .features[0].properties.tile_label;
    if (label.length > 14) {
      label = label.slice(0, 14) + '…';
    }
    return label;
  }

  function getLabelMobile() {
    let label =
      polygonJson.features[0].features[parseInt(getNum(currentTile.name))]
        .features[0].properties.tile_label;
    let label1 = label;
    let label2 = 'F';
    if (label.length > 36) {
      // label1 = label.slice(0, 19)
      // label2 = label.slice(19, 36)
      // if (label2.length > 16) {
      //   label2 = label2 + "…"
      // }
      label = label.slice(0, 36) + '…';
    }

    return label;
  }

  const getDimensions = (geometry) => {
    return [
      geometry.coordinates[0][3][0] - geometry.coordinates[0][0][0],
      geometry.coordinates[0][0][1] - geometry.coordinates[0][1][1],
    ];
  };
  function findNewScale() {
    let og_height = getDimensions(
      polygonJson.features[0].features[parseInt(getNum(currentTile.name))]
        .features[0].geometry
    )[1];
    let new_height = document
      .getElementById('sidebar-video')
      .getBoundingClientRect().height;
    let ratio = new_height / og_height;
    return ratio;
  }
  function getTranslation() {
    let parent_top_left =
      polygonJson.features[0].features[parseInt(getNum(currentTile.name))]
        .features[0].geometry.coordinates[0][0];
    let child_top_left = currentPrompt[2].coordinates[0][0];
    return [
      child_top_left[0] - parent_top_left[0],
      parent_top_left[1] - child_top_left[1],
    ];
  }
  function drawSubRegionBox() {
    if (
      currentPrompt[2] === undefined ||
      null == document.getElementById('sidebar-video')
    ) {
      return [0, 0, 0, 0];
    } else {
      let r = findNewScale();
      let topLeft = [getTranslation()[0] * r, getTranslation()[1] * r];
      let size = [
        getDimensions(currentPrompt[2])[0] * r,
        getDimensions(currentPrompt[2])[1] * r,
      ];
      return [topLeft[0], topLeft[1], size[0], size[1]];
    }
  }

  useEffect(() => {
    var vidbox = document.getElementsByClassName('subregion-video-box')[0];
    vidbox.style.display = 'none';
  }, [masterTile]);

  useEffect(() => {
    var vidbox = document.getElementsByClassName('subregion-video-box')[0];
    if (subregionMode !== -1) {
      vidbox.style.color = configuration.subtile_select_color;
    } else {
      vidbox.style.color = configuration.subtile_hover_color;
    }
  }, [subregionMode]);

  useEffect(() => {
    //do we need singleRegion?
    if (currentPrompt !== null && singleRegion !== true) {
      let box = drawSubRegionBox();
      var vidbox = document.getElementsByClassName('subregion-video-box')[0];
      vidbox.style.opacity = 1;
      //console.log(box)
      let translate = 'translate(';
      let translatetxt = translate.concat(
        String(parseInt(box[0])),
        'px,',
        String(parseInt(box[1])),
        'px)'
      );
      vidbox.style.transform = translatetxt;

      vidbox.style.width = String(box[2]) + 'px';
      vidbox.style.height = String(box[3]) + 'px';
    } else {
      // var vidbox = document.getElementsByClassName('subregion-video-box')[0];
      // vidbox.style.display = "none";
    }
  }, [currentPrompt, singleRegion]);

  function isIsolatedWord(str, word) {
    const index = str.toLowerCase().indexOf(word.toLowerCase());
    if (index === -1) {
      return false;
    }
    const before = index === 0 ? ' ' : str.charAt(index - 1);
    const after =
      index + word.length === str.length
        ? ' '
        : str.charAt(index + word.length);
    return !/\w/.test(before) && !/\w/.test(after);
  }

  function findMatchingSubstring(str1, str2) {
    if (
      str1 === str2 ||
      str1.toLowerCase() === str2 ||
      str1.toUpperCase() === str2
    ) {
      return str1;
    }
    const str2Lower = str2.toLowerCase();
    if (str1.toLowerCase().includes(str2Lower) || str1.includes(str2)) {
      const index = str1
        .toLowerCase()
        .search(new RegExp(`${str2Lower}|${str2}`));
      return str1.slice(index, index + str2.length);
    }
    return null;
  }

  //Adding green wikipedia links to the prompts
  useEffect(() => {
    const textElement = document.getElementById('scrolling-prompt');
    if (currentPrompt !== null && textElement !== null) {
      // Get the text content
      var textContent = textElement.textContent;
      const modifiedString = String(currentPrompt[3]).replace(/\s+/g, '_');
      let link = 'https://en.wikipedia.org/wiki/' + modifiedString;
      var link_color;
      if (ownership[sidebarTitle] == 2) {
        link_color = configuration.yours_hyperlink_color;
      } else if (ownership[sidebarTitle] == 1) {
        link_color = configuration.owned_hyperlink_color;
      } else {
        link_color = configuration.sidebar_hyperlink_color;
      }
      if (currentPrompt[3] !== null) {
        if (textContent.includes(currentPrompt[3])) {
          // Highlight the phrase with RGB(38,252,57)
          let greentext =
            '<a style="text-decoration: none; color:' +
            link_color +
            '" ' +
            'href='.concat(
              link,
              ' target="_blank">'.concat(String(currentPrompt[3]), '</a>')
            );
          textContent = textContent.replace(currentPrompt[3], greentext);
        } else if (
          findMatchingSubstring(textContent, currentPrompt[3]) !== null
        ) {
          // Highlight the phrase with RGB(38,252,57)
          let greentext =
            '<a style="text-decoration: none; color:' +
            link_color +
            '" ' +
            'href='.concat(
              link,
              ' target="_blank">'.concat(
                String(findMatchingSubstring(textContent, currentPrompt[3])),
                '</a>'
              )
            );
          textContent = textContent.replace(
            findMatchingSubstring(textContent, currentPrompt[3]),
            greentext
          );
        } else {
          let wiki_split = currentPrompt[3].split(' ');
          let text_content_split = textContent.split(' ');
          let function_words = [
            'a',
            'an',
            'the',
            'and',
            'but',
            'or',
            'for',
            'nor',
            'so',
            'yet',
            'if',
            'of',
            'at',
            'by',
            'in',
            'to',
            'on',
            'not',
          ]; 
          var count = 0;
          for (let i = 0; i < wiki_split.length; i++) {
            let word = wiki_split[i];
            if (!function_words.includes(word.toLowerCase())) {
              let stripped = word.replace(/[^\w\s]/gi, '');
              for (let n = 0; n < text_content_split.length; n++) {
                if (
                  isIsolatedWord(text_content_split[n], wiki_split[i]) &&
                  text_content_split[n]
                    .toLowerCase()
                    .includes(wiki_split[i].toLowerCase())
                ) {
                  var greentext =
                    '<a style="text-decoration: none; color:' +
                    link_color +
                    '" ' +
                    'href='.concat(link, ' target="_blank">');
                  greentext = greentext.concat(
                    String(text_content_split[n]),
                    '</a> '
                  );
                  text_content_split[n] = greentext;
                  count = count + 1;
                  break;
                }
                if (
                  isIsolatedWord(text_content_split[n], stripped) &&
                  text_content_split[n]
                    .toLowerCase()
                    .includes(stripped.toLowerCase())
                ) {
                  var greentext =
                    '<a style="text-decoration: none; color:' +
                    link_color +
                    '" ' +
                    'href='.concat(link, ' target="_blank">');
                  greentext = greentext.concat(
                    String(text_content_split[n]),
                    '</a> '
                  );
                  text_content_split[n] = greentext;
                  count = count + 1;
                  break;
                }
              }
            }
          }
          /*
          if(count == 0){
            var greentext = '<a style="text-decoration: none; color:RGB(38,252,57)" href='.concat(link, ' style="color: RGB(38,252,57)" target="_blank">')
            greentext = greentext.concat("*", '</a> ');
            text_content_split.push(greentext)
          }*/
          textContent = text_content_split.join(' ');
        }
        textElement.innerHTML = textContent;
      }
    }
  }, [currentPrompt, singleRegion, frameNum]);

  useEffect(() => {
    L.DomEvent.disableClickPropagation(sidebarRef.current);
  });

  useEffect(() => {
    // Get the video element
    const video = document.getElementById('sidebar-video');

    if (video) {
      // add this check
      if (isPaused) {
        if (video.src.slice(-3) === 'mp4') {
          // Set the desired frame time in seconds
          const frameTime = (frameNum * 8.33) / 10.0;

          // Set the current time of the video
          video.currentTime = frameTime;

          // Pause the video
          video.pause();
        }
      }
      // Unpause the video
      if (!isPaused) {
        if (video.src.slice(-3) === 'mp4') {
          video.play();
        }
      }
    }
  }, [isPaused, frameNum]);

  useEffect(() => {
    L.DomEvent.disableClickPropagation(sidebarRef.current);
  });

  return (
    <div
      className="sidebar"
      style={{
        backgroundColor:
          ownership[sidebarTitle] === 2
            ? configuration.yours_sidebar_base_color
            : ownership[sidebarTitle] === 1
            ? configuration.owned_sidebar_base_color
            : configuration.sidebar_base_color,
      }}
      ref={sidebarRef}
    >
      <div className="sub-sidebar unselectable">
        {/* Should Ultimately Switch Into 3 Types Of Components */}

        {subregionMode !== -1 ? (
          <div className="sidebar-swipe-placeholder"> </div>
        ) : (
          <div className="sidebar-swipe"> </div>
        )}

        <div>
          <div
            className="sidebar-close"
            style={{
              color:
                ownership[sidebarTitle] === 2
                  ? configuration.yours_sidebar_buttons_color
                  : ownership[sidebarTitle] === 1
                  ? configuration.owned_sidebar_buttons_color
                  : configuration.sidebar_buttons_color,
            }}
            onClick={() => {
              var sidebar = document.getElementsByClassName('sidebar')[0];
              sidebar.style.animation = 'fadeSidebarOut 0.35s';
              // console.log(sidebar.style.animation);
              setTimeout(() => {
                setSidebar(0);
              }, 340);

              //var darken = document.getElementById('mobile-darken');
              //darken.style.animation = "fadeDarkOut 0.5s";
              //darken.style.visibility = "hidden";
              setSidebar(0);
              var urlId = '/todem/';
              window.history.pushState('', '', urlId);
              var newMasterTile = {
                masterTile: {
                  name: 'Click on a tile!',
                  tokenId: 'NaN',
                  sentimentX_token: '',
                  sentimentY_token: '',
                  img_prompt: '',
                  wiki_token: '',
                  rgb: '',
                  dimensions: ['', ''],
                },
              };
              setMasterTile(newMasterTile);
              setSelectedSubregionNull();
              setSubregionMode(-1);
              setCurrentPrompt(null);
              setTilePreview(-1);
            }}
          >
            <IoIosClose className="icon" style={{ fontSize: 25 }} />
          </div>
        </div>

        <div id="grid-container-container">
          <div className="grid-container">
            <div
              style={{
                backgroundColor:
                  ownership[sidebarTitle] === 2
                    ? configuration.yours_sidebar_background_color
                    : ownership[sidebarTitle] === 1
                    ? configuration.owned_sidebar_background_color
                    : configuration.sidebar_background_color,
                borderColor:
                  ownership[sidebarTitle] === 2
                    ? configuration.yours_sidebar_border_color
                    : ownership[sidebarTitle] === 1
                    ? configuration.owned_sidebar_border_color
                    : configuration.sidebar_border_color,
              }}
              className="grid-item grid-item-1"
            >
              {DetectDevice ? (
                <div
                  className="flex-container"
                  style={
                    subregionMode !== -1
                      ? {
                          paddingLeft: '12.5%',
                          paddingRight: '12.5%',
                          width: '100%',
                        }
                      : { paddingLeft: '5%', paddingRight: '5%', width: '100%' }
                  }
                >
                  {subregionMode !== -1 ? (
                    <>
                      <div
                        className="title-column"
                        style={{ textAlign: 'right' }}
                      >
                        <p
                          id="tile"
                          style={{
                            color:
                              ownership[sidebarTitle] === 2
                                ? configuration.yours_sidebar_text_color
                                : ownership[sidebarTitle] === 1
                                ? configuration.owned_sidebar_text_color
                                : configuration.sidebar_text_color,
                            paddingTop: '.35em',
                          }}
                        >
                          Tile&nbsp;
                        </p>
                      </div>
                      <div
                        className="title-column"
                        style={{ textAlign: 'left' }}
                      >
                        <title
                          className="tile-right"
                          style={{
                            color:
                              ownership[sidebarTitle] === 2
                                ? configuration.yours_sidebar_text_color
                                : ownership[sidebarTitle] === 1
                                ? configuration.owned_sidebar_text_color
                                : configuration.sidebar_text_color,
                          }}
                        >
                          {getNum(currentTile.name)}
                        </title>
                      </div>
                      <div
                        className="title-column"
                        style={{ textAlign: 'right' }}
                      >
                        <p
                          id="tile"
                          style={{
                            color:
                              ownership[sidebarTitle] === 2
                                ? configuration.yours_sidebar_text_color
                                : ownership[sidebarTitle] === 1
                                ? configuration.owned_sidebar_text_color
                                : configuration.sidebar_text_color,
                            paddingTop: '.35em',
                          }}
                        >
                          Subtile&nbsp;
                        </p>
                      </div>
                      <div
                        className="title-column"
                        style={{ textAlign: 'left' }}
                      >
                        {subregionMode !== -1 ? (
                          <title
                            className="tile-right"
                            style={{
                              color:
                                ownership[sidebarTitle] === 2
                                  ? configuration.yours_sidebar_text_color
                                  : ownership[sidebarTitle] === 1
                                  ? configuration.owned_sidebar_text_color
                                  : configuration.sidebar_text_color,
                            }}
                          >
                            {currentPrompt[0]}
                          </title>
                        ) : (
                          <title
                            className="tile-right"
                            style={{
                              color:
                                ownership[sidebarTitle] === 2
                                  ? configuration.yours_sidebar_text_color
                                  : ownership[sidebarTitle] === 1
                                  ? configuration.owned_sidebar_text_color
                                  : configuration.sidebar_text_color,
                            }}
                          >
                            {' '}
                            -{' '}
                          </title>
                        )}
                      </div>
                    </>
                  ) : (
                    <div className="title-column">
                      <title
                        className="tile-right"
                        style={{
                          color:
                            ownership[sidebarTitle] === 2
                              ? configuration.yours_sidebar_text_color
                              : ownership[sidebarTitle] === 1
                              ? configuration.owned_sidebar_text_color
                              : configuration.sidebar_text_color,
                        }}
                      >
                        {getNum(currentTile.name)}
                      </title>
                    </div>
                  )}
                </div>
              ) : (
                <title
                  id="sidebartitle"
                  style={{
                    color:
                      ownership[sidebarTitle] === 2
                        ? configuration.yours_sidebar_text_color
                        : ownership[sidebarTitle] === 1
                        ? configuration.owned_sidebar_text_color
                        : configuration.sidebar_text_color,
                  }}
                >
                  {getNum(currentTile.name)}
                </title>
              )}

              {!DetectDevice || (DetectDevice && subregionMode == -1) ? (
                <div
                  className="sidebar-copy"
                  style={{
                    color:
                      ownership[sidebarTitle] === 2
                        ? configuration.yours_sidebar_buttons_color
                        : ownership[sidebarTitle] === 1
                        ? configuration.owned_sidebar_buttons_color
                        : configuration.sidebar_buttons_color,
                  }}
                  onClick={() => {
                    var currentUrl = window.location.href;

                    let split_url = currentUrl.split('/');
                    if (split_url[split_url.length - 1].length > 4) {
                      currentUrl = currentUrl.slice(0, -5);
                    }

                    navigator.clipboard.writeText(currentUrl);

                    //need to put in copy feedback
                    var copy = document.getElementById('feedback-container');
                    if (copy) {
                      copy.style.display = 'block';
                      copy.style.opacity = 1;
                      clearTimeout(copyTimer);
                      copyTimer = setTimeout(() => {
                        copy.style.opacity = 0;
                      }, 3000);
                    }
                  }}
                >
                  <IoCopyOutline
                    className="icon"
                    id="close-icon"
                    style={{ fontSize: 18 }}
                  />
                </div>
              ) : null}

              {DetectDevice && subregionMode !== -1 ? (
                <div
                  className="sidebar-return"
                  onClick={() => {
                    setSelectedSubregionNull();
                    //subregionSelected = false;
                    subregionMode = false;
                    var queryNumObject = {
                      number: currentTile.name.split('-')[1],
                    };
                    var shouldZoom = 1;
                    selectQueriedClone({
                      map,
                      gridOverlay,
                      sidebarState,
                      setMasterTile,
                      setSidebarTitle,
                      shouldZoom,
                      queryNumObject,
                      setTilePreview,
                    });
                    setSubregionMode(-1);
                    map.touchZoom.enable();
                    map.dragging.enable();
                  }}
                >
                  <RiArrowGoBackFill
                    className="icon"
                    id="return-icon"
                    style={{ fontSize: 20 }}
                  />
                </div>
              ) : null}
            </div>

            <div
              className="grid-item grid-item-2"
              style={{
                backgroundColor:
                  ownership[sidebarTitle] === 2
                    ? configuration.yours_sidebar_background_color
                    : ownership[sidebarTitle] === 1
                    ? configuration.owned_sidebar_background_color
                    : configuration.sidebar_background_color,
                borderColor:
                  ownership[sidebarTitle] === 2
                    ? configuration.yours_sidebar_border_color
                    : ownership[sidebarTitle] === 1
                    ? configuration.owned_sidebar_border_color
                    : configuration.sidebar_border_color,
              }}
            >

              {subregionMode === -1 ? (
                <div className="video-container">
                  <div className="video1-formatter">
                    <div className="subregion-helper">
                      <div className="subregion-video-box"></div>
                      {video_path !== '' && (
                        <video
                          id="sidebar-video"
                          style={{
                            borderStyle: 'solid',
                            borderWidth: '2px',
                            color: configuration.tile_select_color,
                            borderRadius: '3px',
                            opacity: trackVideoRect !== null ? 1 : 0,
                          }}
                          className="icon video1"
                          autoPlay={!isPaused}
                          loop
                          muted
                          playsInline={true}
                          src={video_path}
                          type="video/mp4"
                          poster={poster_path}
                          onCanPlayThrough={(e) => {
                            var vidbox = document.getElementsByClassName(
                              'subregion-video-box'
                            )[0];
                            vidbox.style.opacity = 0;
                            vidbox.style.display = 'block';

                            e.target.style.color =
                              configuration.tile_select_color;
                            if (isPaused) {
                              const frameTime = (frameNum * 8.33) / 10.0;
                              e.target.currentTime = frameTime;
                            }
                          }}
                        ></video>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="video-container">
                  <div className="video1-formatter">
                    <div className="subregion-helper">
                      <div className="subregion-video-box"></div>
                      {video_path !== '' && (
                        <video
                          id="sidebar-video"
                          className="icon video1"
                          autoPlay={!isPaused}
                          poster={poster_path}
                          loop
                          muted
                          playsInline={true}
                          src={video_path}
                          type="video/mp4"
                          onCanPlayThrough={(e) => {
                            var vidbox = document.getElementsByClassName(
                              'subregion-video-box'
                            )[0];
                            vidbox.style.display = 'block';
                            if (
                              currentPrompt !== null &&
                              singleRegion !== true
                            ) {
                              let box = drawSubRegionBox();
                              var vidbox = document.getElementsByClassName(
                                'subregion-video-box'
                              )[0];
                              //console.log(box)
                              let translate = 'translate(';
                              let translatetxt = translate.concat(
                                String(parseInt(box[0])),
                                'px,',
                                String(parseInt(box[1])),
                                'px)'
                              );
                              vidbox.style.transform = translatetxt;

                              vidbox.style.width = String(box[2]) + 'px';
                              vidbox.style.height = String(box[3]) + 'px';
                            }

                            const frameTime = (frameNum * 8.33) / 10.0;
                            if (isPaused) {
                              e.target.currentTime = frameTime;
                            }
                          }}
                        ></video>
                      )}
                    </div>
                  </div>
                </div>
              )}
              {!DetectDevice ? (
                <div className="flex-container navigation">
                  <div className="flex-column nav-item">
                    <div
                      className="sidebar-last-button"
                      style={{
                        color:
                          ownership[sidebarTitle] === 2
                            ? configuration.yours_sidebar_buttons_color
                            : ownership[sidebarTitle] === 1
                            ? configuration.owned_sidebar_buttons_color
                            : configuration.sidebar_buttons_color,
                      }}
                      onClick={() => {
                        let shouldZoom = 1;
                        selectPreviousClone({
                          map,
                          gridOverlay,
                          sidebarState,
                          setMasterTile,
                          setSidebarTitle,
                          shouldZoom,
                          currentTile,
                          setCurrentPrompt,
                        });
                        setSubregionMode(-1);
                        setCurrentPrompt(null);
                      }}
                    >
                      <IoIosArrowBack
                        className="icon"
                        style={{ fontSize: 19 }}
                      />

                      <span
                        className="tooltiptext tooltiptext-last "
                        style={{
                          backgroundColor:
                            configuration.tooltip_background_color,
                          color: configuration.tooltip_text_color,
                        }}
                      >
                        prev
                      </span>
                    </div>
                  </div>

                  <div className="flex-column nav-item shuffle-item">
                    <div
                      className="shuffle"
                      style={{
                        color:
                          ownership[sidebarTitle] === 2
                            ? configuration.yours_sidebar_buttons_color
                            : ownership[sidebarTitle] === 1
                            ? configuration.owned_sidebar_buttons_color
                            : configuration.sidebar_buttons_color,
                      }}
                      onClick={() => {
                        // console.log(setSidebar)
                        setSidebar(1);
                        let shouldZoom = 1;
                        selectRandomClone({
                          map,
                          gridOverlay,
                          sidebarState,
                          setMasterTile,
                          setSidebarTitle,
                          shouldZoom,
                          setCurrentPrompt,
                        });
                        setSubregionMode(-1);
                        setCurrentPrompt(null);
                      }}
                    >
                      <TiArrowShuffle
                        className="icon"
                        style={{ fontSize: 17 }}
                      />

                      <span
                        className="tooltiptext tooltiptext-shuffle "
                        style={{
                          backgroundColor:
                            configuration.tooltip_background_color,
                          color: configuration.tooltip_text_color,
                        }}
                      >
                        shuffle
                      </span>
                    </div>
                  </div>

                  <div className="flex-column nav-item">
                    <div
                      className="sidebar-next-button"
                      style={{
                        color:
                          ownership[sidebarTitle] === 2
                            ? configuration.yours_sidebar_buttons_color
                            : ownership[sidebarTitle] === 1
                            ? configuration.owned_sidebar_buttons_color
                            : configuration.sidebar_buttons_color,
                      }}
                      onClick={() => {
                        let shouldZoom = 1;
                        selectNextClone({
                          map,
                          gridOverlay,
                          sidebarState,
                          setMasterTile,
                          setSidebarTitle,
                          shouldZoom,
                          currentTile,
                          setCurrentPrompt,
                        });
                        setSubregionMode(-1);
                        setCurrentPrompt(null);
                      }}
                    >
                      <IoIosArrowForward
                        style={{ fontSize: 19 }}
                        className="icon"
                      />

                      <span
                        className="tooltiptext tooltiptext-next "
                        style={{
                          backgroundColor:
                            configuration.tooltip_background_color,
                          color: configuration.tooltip_text_color,
                        }}
                      >
                        next
                      </span>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>

            {DetectDevice && subregionMode !== -1 ? (
              <div
                className="grid-item grid-item-3"
                style={{
                  backgroundColor:
                    ownership[sidebarTitle] === 2
                      ? configuration.yours_sidebar_background_color
                      : ownership[sidebarTitle] === 1
                      ? configuration.owned_sidebar_background_color
                      : configuration.sidebar_background_color,
                  borderColor:
                    ownership[sidebarTitle] === 2
                      ? configuration.yours_sidebar_border_color
                      : ownership[sidebarTitle] === 1
                      ? configuration.owned_sidebar_border_color
                      : configuration.sidebar_border_color,
                }}
              >
                <div className="prompt-container-mobile">
                  <div className="prompt-title-mobile">
                    prompt
                    <div
                      className="sidebar-subtile-copy"
                      style={{
                        color:
                          ownership[sidebarTitle] === 2
                            ? configuration.yours_sidebar_buttons_color
                            : ownership[sidebarTitle] === 1
                            ? configuration.owned_sidebar_buttons_color
                            : configuration.sidebar_buttons_color,
                      }}
                      onClick={() => {
                        var currentUrl = window.location.href;

                        navigator.clipboard.writeText(currentUrl);

                        //need to put in copy feedback
                        var copy =
                          document.getElementById('feedback-container');
                        if (copy) {
                          copy.style.display = 'block';
                          copy.style.opacity = 1;
                          clearTimeout(copyTimer);
                          copyTimer = setTimeout(() => {
                            copy.style.opacity = 0;
                          }, 3000);
                        }
                      }}
                    >
                      <IoCopyOutline
                        className="icon"
                        id="close-icon"
                        style={{ fontSize: 18 }}
                      />
                    </div>
                  </div>

                  <p
                    onMouseOver={() => {
                      map.smoothWheelZoom.disable();
                      map.scrollWheelZoom.disable();
                    }}
                    onMouseOut={() => {
                      map.smoothWheelZoom.enable();
                    }}
                    id="scrolling-prompt"
                  >
                    {currentPrompt === null ? null : currentPrompt[1]}
                  </p>
                </div>
              </div>
            ) : (
              <div
                className="grid-item grid-item-3"
                style={{
                  backgroundColor:
                    ownership[sidebarTitle] === 2
                      ? configuration.yours_sidebar_background_color
                      : ownership[sidebarTitle] === 1
                      ? configuration.owned_sidebar_background_color
                      : configuration.sidebar_background_color,
                  borderColor:
                    ownership[sidebarTitle] === 2
                      ? configuration.yours_sidebar_border_color
                      : ownership[sidebarTitle] === 1
                      ? configuration.owned_sidebar_border_color
                      : configuration.sidebar_border_color,
                }}
              >
                <div className="flex-container">
                  <div className="flex-column">
                    {DetectDevice ? (
                      <div className="text-item" style={{ width: '100vw' }}>
                        <p
                          style={{
                            color:
                              ownership[sidebarTitle] === 2
                                ? configuration.yours_sidebar_label_color
                                : ownership[sidebarTitle] === 1
                                ? configuration.owned_sidebar_label_color
                                : configuration.sidebar_label_color,
                          }}
                        >
                          Label
                        </p>
                        <br></br>
                        <p
                          style={{
                            columnSpan: 'all',
                            color:
                              ownership[sidebarTitle] === 2
                                ? configuration.yours_sidebar_text_color
                                : ownership[sidebarTitle] === 1
                                ? configuration.owned_sidebar_text_color
                                : configuration.sidebar_text_color,
                          }}
                        >
                          {getLabelMobile()}
                        </p>
                        <br></br>
                      </div>
                    ) : null}

                    <div id="shortLabel">
                      {DetectDevice ? (
                        <p
                          className="labeltoken"
                          style={{
                            color:
                              ownership[sidebarTitle] === 2
                                ? configuration.yours_sidebar_label_color
                                : ownership[sidebarTitle] === 1
                                ? configuration.owned_sidebar_label_color
                                : configuration.sidebar_label_color,
                          }}
                        >
                          Label
                        </p>
                      ) : (
                        <p
                          style={{
                            color:
                              ownership[sidebarTitle] === 2
                                ? configuration.yours_sidebar_label_color
                                : ownership[sidebarTitle] === 1
                                ? configuration.owned_sidebar_label_color
                                : configuration.sidebar_label_color,
                          }}
                        >
                          Label
                        </p>
                      )}
                      <br></br>
                      <p
                        className="labeltoken"
                        style={{
                          color:
                            ownership[sidebarTitle] === 2
                              ? configuration.yours_sidebar_text_color
                              : ownership[sidebarTitle] === 1
                              ? configuration.owned_sidebar_text_color
                              : configuration.sidebar_text_color,
                        }}
                      >
                        {getLabel()}
                      </p>
                      <br></br>
                    </div>

                    <div className="text-item">
                      <div>
                        <br></br>
                        <p
                          style={{
                            color:
                              ownership[sidebarTitle] === 2
                                ? configuration.yours_sidebar_label_color
                                : ownership[sidebarTitle] === 1
                                ? configuration.owned_sidebar_label_color
                                : configuration.sidebar_label_color,
                          }}
                        >
                          Class
                        </p>
                        <br></br>
                        <p
                          style={{
                            color:
                              ownership[sidebarTitle] === 2
                                ? configuration.yours_sidebar_text_color
                                : ownership[sidebarTitle] === 1
                                ? configuration.owned_sidebar_text_color
                                : configuration.sidebar_text_color,
                          }}
                        >
                          {currentTile.name[5]}
                        </p>
                      </div>
                    </div>
                    <div className="text-item">
                      {!redactNFTs && !DetectDevice ? (
                        <div>
                          <br></br>
                          <p
                            style={{
                              color:
                                ownership[sidebarTitle] === 2
                                  ? configuration.yours_sidebar_label_color
                                  : ownership[sidebarTitle] === 1
                                  ? configuration.owned_sidebar_label_color
                                  : configuration.sidebar_label_color,
                            }}
                          >
                            Price{' '}
                            {' '}
                          </p>
                          <br></br>
                          {!ownership[currentTile.tokenId] ? (
                            <div>
                              {currentETHPrice.toFixed(8) !==
                              calcPrice.toFixed(8) ? (
                                <p
                                  style={{
                                    color:
                                      ownership[sidebarTitle] === 2
                                        ? configuration.yours_sidebar_text_color
                                        : ownership[sidebarTitle] === 1
                                        ? configuration.owned_sidebar_text_color
                                        : configuration.sidebar_text_color,
                                  }}
                                >
                                  <del>
                                    {getPrice(currentTile.tokenId).toFixed(5)}
                                  </del>{' '}
                                  eth <br></br> {currentETHPrice.toFixed(5)} eth
                                </p>
                              ) : (
                                <p
                                  style={{
                                    color:
                                      ownership[sidebarTitle] === 2
                                        ? configuration.yours_sidebar_text_color
                                        : ownership[sidebarTitle] === 1
                                        ? configuration.owned_sidebar_text_color
                                        : configuration.sidebar_text_color,
                                  }}
                                >
                                  {currentETHPrice.toFixed(5)} eth
                                </p>
                              )}
                            </div>
                          ) : listedPrice === null ? (
                            <p
                              style={{
                                color:
                                  ownership[sidebarTitle] === 2
                                    ? configuration.yours_sidebar_text_color
                                    : ownership[sidebarTitle] === 1
                                    ? configuration.owned_sidebar_text_color
                                    : configuration.sidebar_text_color,
                              }}
                            >
                              - <br></br>
                            </p>
                          ) : (
                            <p
                              style={{
                                color:
                                  ownership[sidebarTitle] === 2
                                    ? configuration.yours_sidebar_text_color
                                    : ownership[sidebarTitle] === 1
                                    ? configuration.owned_sidebar_text_color
                                    : configuration.sidebar_text_color,
                              }}
                            >
                              {parseFloat(listedPrice).toFixed(5)} eth <br></br>
                            </p>
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="flex-column">
                    {DetectDevice ? (
                      <div className="text-item">
                        <p style={{ opacity: 0 }}>Empty</p>
                        <br></br>
                        <p style={{ opacity: 0 }}>Empty</p>
                        <br></br>
                      </div>
                    ) : null}
                    <div id="dimensions">
                      <p
                        style={{
                          color:
                            ownership[sidebarTitle] === 2
                              ? configuration.yours_sidebar_label_color
                              : ownership[sidebarTitle] === 1
                              ? configuration.owned_sidebar_label_color
                              : configuration.sidebar_label_color,
                        }}
                      >
                        Dimensions
                      </p>
                      <br></br>
                      <p
                        style={{
                          color:
                            ownership[sidebarTitle] === 2
                              ? configuration.yours_sidebar_text_color
                              : ownership[sidebarTitle] === 1
                              ? configuration.owned_sidebar_text_color
                              : configuration.sidebar_text_color,
                        }}
                      >
                        {currentTile.dimensions[0]}&thinsp;x&thinsp;
                        {currentTile.dimensions[1]}
                      </p>
                      <br></br>
                    </div>
                    <div className="text-item">
                      <div>
                        <br></br>
                        <p
                          style={{
                            color:
                              ownership[sidebarTitle] === 2
                                ? configuration.yours_sidebar_label_color
                                : ownership[sidebarTitle] === 1
                                ? configuration.owned_sidebar_label_color
                                : configuration.sidebar_label_color,
                          }}
                        >
                          Subtiles
                        </p>
                        <br></br>
                        <p
                          style={{
                            color:
                              ownership[sidebarTitle] === 2
                                ? configuration.yours_sidebar_text_color
                                : ownership[sidebarTitle] === 1
                                ? configuration.owned_sidebar_text_color
                                : configuration.sidebar_text_color,
                          }}
                        >
                          {promptData.features[0].features.length}
                        </p>
                        <br></br>
                      </div>
                    </div>
                    <div className="text-item">
                      {!redactNFTs && !DetectDevice ? (
                        <div>
                          <br></br>
                          {ownership[currentTile.tokenId] ? (
                            <>
                              <p
                              style={{
                                color:
                                  ownership[sidebarTitle] === 2
                                    ? configuration.yours_sidebar_label_color
                                    : ownership[sidebarTitle] === 1
                                    ? configuration.owned_sidebar_label_color
                                    : configuration.sidebar_label_color,
                              }}
                            >
                            TPX
                            </p>
                            </>
                          ): null }
                          <br></br>                          
                          {!ownership[currentTile.tokenId] ? (
                            <div>
                              {currentETHPrice.toFixed(8) !==
                              calcPrice.toFixed(8) ? (
                                <p
                                  style={{
                                    color:
                                      ownership[sidebarTitle] === 2
                                        ? configuration.yours_sidebar_usd_price_color
                                        : ownership[sidebarTitle] === 1
                                        ? configuration.owned_sidebar_usd_price_color
                                        : configuration.sidebar_usd_price_color,
                                  }}
                                >
                                  (
                                  <del>
                                    <NumericFormat
                                      style={{
                                        color:
                                          ownership[sidebarTitle] === 2
                                            ? configuration.yours_sidebar_usd_price_color
                                            : ownership[sidebarTitle] === 1
                                            ? configuration.owned_sidebar_usd_price_color
                                            : configuration.sidebar_usd_price_color,
                                      }}
                                      value={(
                                        getPrice(currentTile.tokenId) * ETHTOUSD
                                      ).toFixed(2)}
                                      displayType="text"
                                      thousandSeparator=","
                                      prefix={'$'}
                                    />
                                  </del>
                                  )<br></br> (
                                  <NumericFormat
                                    style={{
                                      color:
                                        ownership[sidebarTitle] === 2
                                          ? configuration.yours_sidebar_usd_price_color
                                          : ownership[sidebarTitle] === 1
                                          ? configuration.owned_sidebar_usd_price_color
                                          : configuration.sidebar_usd_price_color,
                                    }}
                                    value={(currentETHPrice * ETHTOUSD).toFixed(
                                      2
                                    )}
                                    displayType="text"
                                    thousandSeparator=","
                                    prefix={'$'}
                                  />
                                  )
                                </p>
                              ) : (
                                <p
                                  style={{
                                    color:
                                      ownership[sidebarTitle] === 2
                                        ? configuration.yours_sidebar_usd_price_color
                                        : ownership[sidebarTitle] === 1
                                        ? configuration.owned_sidebar_usd_price_color
                                        : configuration.sidebar_usd_price_color,
                                  }}
                                >
                                  (
                                  <NumericFormat
                                    style={{
                                      color:
                                        ownership[sidebarTitle] === 2
                                          ? configuration.yours_sidebar_usd_price_color
                                          : ownership[sidebarTitle] === 1
                                          ? configuration.owned_sidebar_usd_price_color
                                          : configuration.sidebar_usd_price_color,
                                    }}
                                    value={(
                                      getPrice(currentTile.tokenId) * ETHTOUSD
                                    ).toFixed(2)}
                                    displayType="text"
                                    thousandSeparator=","
                                    prefix={'$'}
                                  />
                                  )<br></br>
                                </p>
                              )}
                            </div>
                          ) : TPXclaimed ? (
                            <>
                              <p
                                style={{
                                  color:
                                    ownership[sidebarTitle] === 2
                                      ? configuration.yours_sidebar_usd_price_color
                                      : ownership[sidebarTitle] === 1
                                      ? configuration.owned_sidebar_usd_price_color
                                      : configuration.sidebar_usd_price_color,
                                  opacity: 0.25,
                                }}
                              >
                              claimed
                              </p>
                              <br></br>
                            </>
                          ) : (
                            <>
                              <p
                                style={{
                                  color:
                                    ownership[sidebarTitle] === 2
                                      ? configuration.yours_sidebar_text_color
                                      : ownership[sidebarTitle] === 1
                                      ? configuration.owned_sidebar_text_color
                                      : configuration.sidebar_text_color,
                                }}
                              >
                              unclaimed
                              </p>
                              <br></br>
                            {/*
                            <span
                              style={{
                                color:
                                  ownership[sidebarTitle] === 2
                                    ? configuration.yours_sidebar_usd_price_color
                                    : ownership[sidebarTitle] === 1
                                    ? configuration.owned_sidebar_usd_price_color
                                    : configuration.sidebar_usd_price_color,
                                opacity: 0.25,
                              }}
                            >
                              (
                              <NumericFormat
                                style={{
                                  color:
                                    ownership[sidebarTitle] === 2
                                      ? configuration.yours_sidebar_usd_price_color
                                      : ownership[sidebarTitle] === 1
                                      ? configuration.owned_sidebar_usd_price_color
                                      : configuration.sidebar_usd_price_color,
                                }}
                                value={(listedPrice * ETHTOUSD).toFixed(2)}
                                displayType="text"
                                thousandSeparator=","
                                prefix={'$'}
                              />
                              )
                            </span>*/}
                            </>
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="bottom-row"></div>
              </div>
            )}

            {DetectDevice && subregionMode === -1 ? (
              <div className="grid-item grid-item-4">
                <div className="flex-container navigation">
                  <div className="flex-column nav-item">
                    <div
                      className="sidebar-last-button"
                      onClick={() => {
                        // console.log("back")
                        let shouldZoom = 1;
                        //setSubregionMode(-1);
                        //setCurrentPrompt(null);
                        selectPreviousClone({
                          map,
                          gridOverlay,
                          sidebarState,
                          setMasterTile,
                          setSidebarTitle,
                          shouldZoom,
                          currentTile,
                          setCurrentPrompt,
                          isMobileFullView,
                        });
                      }}
                    >
                      <IoIosArrowBack
                        className="icon"
                        style={{ fontSize: 24 }}
                      />
                    </div>
                  </div>
                  <div className="flex-column nav-item shuffle-item">
                    <div
                      className="shuffle"
                      onClick={() => {
                        // console.log(setSidebar)
                        setSidebar(1);
                        //setSubregionMode(-1);
                        //setCurrentPrompt(null);
                        let shouldZoom = 1;
                        selectRandomClone({
                          map,
                          gridOverlay,
                          sidebarState,
                          setMasterTile,
                          setSidebarTitle,
                          shouldZoom,
                          setCurrentPrompt,
                          isMobileFullView,
                        });
                      }}
                    >
                      <TiArrowShuffle
                        className="icon"
                        style={{ fontSize: 24 }}
                      />
                    </div>
                  </div>
                  <div className="flex-column nav-item">
                    <div
                      className="sidebar-next-button"
                      onClick={() => {
                        // console.log("forward")

                        let shouldZoom = 1;
                        //setSubregionMode(-1);
                        //setCurrentPrompt(null);
                        selectNextClone({
                          map,
                          gridOverlay,
                          sidebarState,
                          setMasterTile,
                          setSidebarTitle,
                          shouldZoom,
                          currentTile,
                          setCurrentPrompt,
                          isMobileFullView,
                        });
                      }}
                    >
                      <IoIosArrowForward
                        style={{ fontSize: 24 }}
                        className="icon"
                      />
                    </div>
                  </div>
                </div>
              </div>
            ) : null}

            {!DetectDevice || subregionMode === -1 ? (
              <div className="grid-item grid-item-5">
                {!DetectDevice ? (
                  <div
                    className="pop"
                    style={{
                      color:
                        ownership[sidebarTitle] === 2
                          ? configuration.yours_sidebar_pop_color
                          : ownership[sidebarTitle] === 1
                          ? configuration.owned_sidebar_pop_color
                          : configuration.sidebar_pop_color,
                    }}
                    onClick={() => {
                      setPopout(1);
                      setSidebar(0);
                    }}
                  >
                    <IoOpenOutline
                      className="icon invert"
                      style={{ fontSize: 20, strokeWidth: 50 }}
                    />

                    <span
                      className="tooltiptext tooltiptext-pop"
                      style={{
                        backgroundColor: configuration.tooltip_background_color,
                        color: configuration.tooltip_text_color,
                      }}
                    >
                      expand
                    </span>
                  </div>
                ) : redactNFTs ? null : (
                  <div className="mobile-pricing">
                    <div className="pricing-left">
                      <span
                        style={{
                          color:
                            ownership[sidebarTitle] === 2
                              ? configuration.yours_sidebar_label_color
                              : ownership[sidebarTitle] === 1
                              ? configuration.owned_sidebar_label_color
                              : configuration.sidebar_label_color,
                        }}
                      >
                        {' '}
                        Price{' '}
                      </span>
                    </div>
                    {!ownership[currentTile.tokenId] ? (
                      <div className="pricing-right">
                        <div style={{ display: 'flex' }}>
                          <span
                            style={{
                              flex: 1,
                              display: 'inline-block',
                              color: 'rgb(255, 255, 255)',
                            }}
                          >
                            {' '}
                            {currentETHPrice.toFixed(3)}
                          </span>
                          <span
                            style={{
                              flex: 1,
                              display: 'inline-block',
                              marginLeft: 8,
                              marginRight: 8,
                              color: 'rgb(255, 255, 255)',
                            }}
                          >
                            {' '}
                            eth
                          </span>
                        </div>
                      </div>
                    ) : (
                      <div className="pricing-right">
                        <span style={{ color: 'rgb(255, 255, 255)' }}> - </span>
                      </div>
                    )}
                  </div>
                )}

                {!ownership[currentTile.tokenId] ? (
                  <div className="minting">
                    {isMobile ? (
                      <div
                        id="connect"
                        style={{ backgroundColor: 'lightgray' }}
                        onClick={(e) => {
                          var playbox = document.getElementsByClassName(
                            'bttn frame-controller'
                          )[0];
                          playbox.style.visibility = 'hidden';

                          setMintMessage('no_wallet');
                        }}
                      >
                        {redactNFTs ? <>more&thinsp;info</> : 'mint'}
                      </div>
                    ) : (
                      <>
                        {redactNFTs == false &&
                        (blockchain.account === '' ||
                          blockchain.smartContract === null) ? (
                          <div
                            id="connect"
                            onClick={(e) => {
                              setMintMessage('no_wallet');
                              setRevertMessage(
                                'Connect your ethereum wallet via the connect wallet dropdown before minting'
                              );
                            }}
                          >
                            mint
                          </div>
                        ) : (
                          <div
                            id="connect"
                            style={{
                              backgroundColor: mintingPaused ? 'lightgray' : '',
                            }}
                            disabled={claimingNft ? 1 : 0}
                            onClick={
                              redactNFTs
                                ? (e) => {
                                    setPopout(1);
                                    setSidebar(0);
                                  }
                                : (e) => {
                                    e.preventDefault();
                                    mintNFT(currentTile.tokenId);
                                    getData();
                                  }
                            }
                          >
                            {redactNFTs ? (
                              <>more&thinsp;info</>
                            ) : claimingNft ? (
                              'processing'
                            ) : (
                              'mint'
                            )}
                          </div>
                        )}
                      </>
                    )}

                    {redactNFTs ? null : (
                      <img
                        src="https://storage.googleapis.com/opensea-static/Logomark/Logomark-Blue.png"
                        alt="Opensea Icon"
                        id="opensea"
                        style={{
                          opacity: 0.2,
                          filter: 'grayscale(100%)',
                          pointerEvents: 'none',
                        }}
                        onClick={() => {}}
                      ></img>
                    )}
                  </div>
                ) : (
                  <div className="minting">
                    {currentTileOwner === blockchain.account && ownership[sidebarTitle] === 2 && 
                    (currentTile.name[5] == 'B' ||
                      currentTile.name[5] == 'A') ? (
                      <div
                        id="connect_pckg"
                        style={{
                          opacity: physicalClaimed ? 0.3 : 1.0,
                          backgroundColor: physicalClaimed
                            ? 'lightgray'
                            : '#8CCEFF',
                          display: 'inline-block',
                          width: 'fit-content',
                          marginRight: '10px',
                        }}
                      >
                        {!physicalClaimed ? (
                          <span
                            class="pckg"
                            style={{
                              textDecoration: 'none',
                              fontFamily: 'Terminus',
                              fontStyle: 'normal',
                              cursor: 'pointer',
                              color: configuration.yours_sidebar_text_color,
                              display: 'inline-block',
                            }}
                            onClick={() => {
                              setMintMessage('claim_physical');
                            }}
                          >
                            physical
                          </span>
                        ) : (
                          <span
                            style={{
                              textDecoration: 'none',
                              fontFamily: 'Terminus',
                              fontStyle: 'normal',
                              cursor: 'default',
                              color: configuration.yours_sidebar_text_color,
                              display: 'inline-block',
                            }}
                          >
                            claimed
                          </span>
                        )}
                      </div>
                    ) : null}
                    <div
                      id="connect_pckg"
                      onClick={() => {
                        if (currentTileOwner !== blockchain.account || ownership[sidebarTitle] !== 2) {
                          window.open(
                            setWalletLink(currentTileOwner),
                            '_blank'
                          );
                        } else {
                          window.open(constructIPFSLink(currentTile), '_blank');
                        }
                      }}
                      style={{
                        opacity:
                          currentTileOwner !== blockchain.account || ownership[sidebarTitle] !== 2 ? 0.3 : 1.0,
                        backgroundColor:
                          currentTileOwner !== blockchain.account || ownership[sidebarTitle] !== 2
                            ? 'lightgray'
                            : '#8CCEFF',
                        display: 'inline-block',
                        width: 'fit-content',
                      }}
                    >
                      {currentTileOwner === blockchain.account && ownership[sidebarTitle] === 2 ? (
                        <span
                          class="pckg"
                          style={{
                            textDecoration: 'none',
                            fontFamily: 'Terminus',
                            fontStyle: 'normal',
                            cursor: 'pointer',
                            color: configuration.yours_sidebar_text_color,
                            display: 'inline-block',
                          }}
                          onClick={() => {
                            window.open(
                              constructIPFSLink(currentTile),
                              '_blank'
                            );
                          }}
                        >
                          PCKG
                          <CgSoftwareDownload
                            className="icon"
                            style={{
                              fontSize: 20,
                              paddingBottom: '3px',
                              marginRight: '-4px',
                            }}
                          />
                        </span>
                      ) : (
                        <>
                          <span>{currentTileOwner.substring(0, 6)}</span>
                          <span>...</span>
                          <span>{currentTileOwner.slice(-4)}</span>
                        </>
                      )}
                    </div>
                    <img
                      src="https://storage.googleapis.com/opensea-static/Logomark/Logomark-Blue.png"
                      alt="Opensea Icon"
                      id="opensea"
                      style={{ opacity: 1 }}
                      onClick={() => {
                        window.open(setLink(currentTile.tokenId), '_blank');
                      }}
                    ></img>
                  </div>
                )}
              </div>
            ) : null}
          </div>
        </div>
      </div>
      {DetectDevice ? null : (
        <div
          className="prompt-container"
          style={{
            top: !redactNFTs
              ? !ownership[currentTile.tokenId]
                ? currentETHPrice.toFixed(8) ===
                  getPrice(currentTile.tokenId).toFixed(8)
                  ? 515
                  : 525
                : 515
              : 465,
            display: currentPrompt === null ? 'none' : 'block',
            height: `fit-content`,
            backgroundColor:
              ownership[sidebarTitle] === 2
                ? configuration.yours_sidebar_base_color
                : ownership[sidebarTitle] === 1
                ? configuration.owned_sidebar_base_color
                : configuration.sidebar_base_color,
          }}
        >
          <div className="prompt-title">
            <span
              style={{
                color:
                  ownership[sidebarTitle] === 2
                    ? configuration.yours_sidebar_label_color
                    : ownership[sidebarTitle] === 1
                    ? configuration.owned_sidebar_label_color
                    : configuration.sidebar_label_color,
                fontSize: '15px',
              }}
            >
              {' '}
              tile{' '}
            </span>
            <span
              style={{
                color:
                  ownership[sidebarTitle] === 2
                    ? configuration.yours_sidebar_text_color
                    : ownership[sidebarTitle] === 1
                    ? configuration.owned_sidebar_text_color
                    : configuration.sidebar_text_color,
              }}
            >
              {' '}
              {getNum(currentTile.name)}{' '}
            </span>
            &nbsp;
            <span
              style={{
                color:
                  ownership[sidebarTitle] === 2
                    ? configuration.yours_sidebar_label_color
                    : ownership[sidebarTitle] === 1
                    ? configuration.owned_sidebar_label_color
                    : configuration.sidebar_label_color,
                fontSize: '15px',
              }}
            >
              subtile
            </span>
            {currentPrompt === null ? null : (
              <span
                style={{
                  color:
                    ownership[sidebarTitle] === 2
                      ? configuration.yours_sidebar_text_color
                      : ownership[sidebarTitle] === 1
                      ? configuration.owned_sidebar_text_color
                      : configuration.sidebar_text_color,
                }}
              >
                {' '}
                {currentPrompt[0]}{' '}
              </span>
            )}
            <div
              className="sidebar-subtile-copy"
              style={{
                color:
                  ownership[sidebarTitle] === 2
                    ? configuration.yours_sidebar_buttons_color
                    : ownership[sidebarTitle] === 1
                    ? configuration.owned_sidebar_buttons_color
                    : configuration.sidebar_buttons_color,
              }}
              onClick={() => {
                var currentUrl = window.location.href;

                navigator.clipboard.writeText(currentUrl);

                //need to put in copy feedback
                var copy = document.getElementById('feedback-container');
                if (copy) {
                  copy.style.display = 'block';
                  copy.style.opacity = 1;
                  clearTimeout(copyTimer);
                  copyTimer = setTimeout(() => {
                    copy.style.opacity = 0;
                  }, 3000);
                }
              }}
            >
              <IoCopyOutline
                className="icon"
                id="close-icon"
                style={{ fontSize: 18 }}
              />
            </div>
          </div>

          <p
            style={{
              height: `calc(100vh - 635px)`,
              maxHeight: 300,
              borderStyle: 'solid',
              bordersWidth: '2px',
              borderColor:
                subregionMode !== -1
                  ? configuration.subtile_select_color
                  : configuration.subtile_hover_color,
              backgroundColor:
                ownership[sidebarTitle] === 2
                  ? configuration.yours_sidebar_background_color
                  : ownership[sidebarTitle] === 1
                  ? configuration.owned_sidebar_background_color
                  : configuration.sidebar_background_color,
              color:
                ownership[sidebarTitle] === 2
                  ? configuration.yours_sidebar_prompt_box_text_color
                  : ownership[sidebarTitle] === 1
                  ? configuration.owned_sidebar_prompt_box_text_color
                  : configuration.sidebar_prompt_box_text_color,
            }}
            onMouseOver={() => {
              map.smoothWheelZoom.disable();
              map.scrollWheelZoom.disable();
            }}
            onMouseOut={() => {
              map.smoothWheelZoom.enable();
            }}
            id="scrolling-prompt"
          >
            {currentPrompt === null
              ? null
              : frameNum !== 0 || !isPaused
              ? currentPrompt[1]
              : 'A tapestry of decadent meritocracy'}
          </p>
        </div>
      )}
    </div>
  );
}

export default Sidebar;
